import { render } from "./DiagnosticoExpress.vue?vue&type=template&id=af451868&scoped=true"
import script from "./DiagnosticoExpress.vue?vue&type=script&lang=js"
export * from "./DiagnosticoExpress.vue?vue&type=script&lang=js"

import "./DiagnosticoExpress.vue?vue&type=style&index=0&id=af451868&scoped=true&lang=css"

import exportComponent from "/home/runner/work/jeanInformatico-management-system/jeanInformatico-management-system/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-af451868"]])

export default __exports__